module.exports = __webpack_public_path__ + "img/AbdulqadirSaed.c70d7dd3.jpg";